import { lazy } from 'react';

export const PlayerCancelDepositLimitForm = lazy(
  () => import('./PlayerCancelDepositLimitForm'),
);
